<template>
	<div class="common_activity" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" :title="info.name" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
    	<img v-if="isApp && info.is_share==1" @click="applyMerchantShare()" class="share" src="../../assets/common/xb_title_share.png">
		<van-row>
			<van-col span="24" class="content" :style="paddT">
         		<div v-html="info.content"></div>
			</van-col>
		</van-row>
		<van-popup class="tipMSG" v-model="showTip">
			<div class="box">
				<img src="../../assets/common/BG@2x.png" alt />
				<p class="title">温馨提示</p>
				<p class="tips">{{TipMsg}}</p>
				<span class="right right_big" @click="goBack()">好的</span>
			</div>
		</van-popup>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	isApp: true,
		isiOSX: false,
      	showTip: false,
		paddT: {paddingTop: '68px'}, //app内
		info: {},
		TipMsg: ''
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
	}
	this.getInfo();
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	},
    applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
	},
    showPopup(msg) {
		  this.showTip = true;
		  this.TipMsg = msg;
    },
	getInfo() {
		this.$api.get("platformsys/index/activity/detail", {id:this.$route.query.id}).then(res => {
			this.info = res;
		}).catch(err => {
			let keys = Object.keys(err);
			let key = keys[0];
			let message = err.message || err[key][0]
			this.createOrder = false;
			if(err.code != 0) {
				this.showPopup(message);
			}
		});
	}
  }
};
</script>

<style lang="less">
.common_activity {
	background: #ffffff;
	min-height: 100%;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.content{
		width: 100%;
		background: #ffffff;
		img{
			width: 100% !important;
			display: block;
		}
	}
    .tipMSG {
      width: 70%;
      border-radius: 10px;
      .box {
        img {
          display: block;
          width: 100%;
        }
        .title {
          color: #333;
          font-size: 15px;
          font-weight: 600;
          line-height: 47px;
          margin-top: 8px;
          text-align: center;
        }
        .tips {
          color: #333;
          font-size: 13px;
          line-height: 18px;
          text-align: center;
          margin-bottom: 30px;
          padding: 0 10px;
        }
        span {
          width: 50%;
          border-top: solid 1px #f2f2f2;
          line-height: 43px;
          color: #999;
          font-size: 14px;
          text-align: center;
          display: inline-block;
        }
        .right {
          color: #e6212f;
          width: calc(50% - 1px);
          border-left: solid 1px #f2f2f2;
        }
        .right_big {
          width: 100%;
          border-left: none;
        }
      }
    }
}

.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
